<template>
  <!-- <v-dialog persistent max-width="600" scrollable> -->

  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="10" lg="7">
        <ValidationObserver v-slot="{ handleSubmit }">
          <v-card :loading="isLoading" class="shadow-3">
            <v-card-title class="pa-0 shadow-1">
              <v-img
                :src="require('@/assets/illustrations/bg_modal_card.svg')"
                cover
                position="left bottom"
                class="align-center"
                height="65px"
              >
                <v-card-title class="font-weight-medium primary--text">
                  <!-- {{ isEditMode ? "Actualizar" : "Crear" }} tarificador -->
                  Crear Encuesta
                </v-card-title>
              </v-img>
            </v-card-title>

            <vuescroll
              :ops="{
                bar: { background: '#bacfcec0', keepShow: true },
              }"
            >
              <v-card-text style="max-height: 450px">
                <v-row>
                  <!-- Nombre -->
                  <v-col cols="12" class="pb-0">
                    <ValidationProvider
                      name="nombre"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="name"
                        :error-messages="errors"
                        class="rounded-small"
                        label="Nombre"
                        required
                        filled
                        rounded
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <!-- <p class="grey--text caption pb-3">
                                            <v-icon small left color="blue-grey"
                                                >mdi-information</v-icon
                                            >Seleccione un rango de fecha para
                                            la búsqueda.
                                        </p> -->

                    <v-menu
                      ref="dateRangeMenu"
                      v-model="dateRangeMenu"
                      :close-on-content-click="false"
                      :return-value.sync="dates"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dates"
                          required
                          filled
                          rounded
                          class="rounded-small"
                          label="Rango de fecha"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="es-us"
                        v-model="dates"
                        :min="new Date().toISOString().substr(0, 10)"
                        range
                        scrollable
                        no-title
                      >
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            text
                            rounded
                            class="mr-1"
                            :color="hover ? 'error' : 'grey'"
                            @click="dateRangeMenu = false"
                            >Cancelar</v-btn
                          >
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            rounded
                            :loading="isLoading"
                            :disabled="isLoading"
                            color="success"
                            :class="hover ? 'shadow-2' : 'shadow-4'"
                            class="px-8"
                            @click="
                              $refs.dateRangeMenu.save(dates),
                                !module.includes('agents') && getExtensionDate()
                            "
                            >ok</v-btn
                          >
                        </v-hover>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-card-text>
            </vuescroll>
            <v-card-actions>
              <v-btn
                @click="closeDialog()"
                class="px-8"
                color="error"
                rounded
                large
                text
              >
                Cerrar
              </v-btn>
              <v-spacer></v-spacer>

              <v-btn
                @click="handleSubmit(submitForm)"
                :disabled="isLoading"
                class="px-8"
                color="success"
                rounded
                large
              >
                <!-- {{ isEditMode ? "Actualizar" : "Crear" }} -->
                Crear
              </v-btn>
            </v-card-actions>
          </v-card>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
  <!-- </v-dialog> -->
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: {
    vuescroll,
  },

  props: {
    // isActive: {
    //   type: Boolean,
    // },
    // isEditMode: {
    //   type: Boolean,
    //   default: false,
    // },
    // dataToEdit: {
    //   type: Object,
    //   default: {},
    // },
  },

  data() {
    return {
      isLoading: false,
      dateRangeMenu: false,
      dates: [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ],
      name: "",
    };
  },

  created() {
    // this.getSelectsInfo();
    // this.payload = { ...this.dataToEdit };
  },

  methods: {
    resetform() {
      this.payload.name = "";
      this.payload.prefix = "";
      this.payload.longitud = "";
      this.payload.value = "";
      this.payload.bill_type = "";
      this.payload.client_id = null;
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async submitForm() {
      this.isLoading = true;

      // const { id, ...payload } = this.payload;

      try {
        const payload = {
          name: this.name,
          start: this.dates[0],
          end: this.dates[1],
        };

        const { data } = await PbxHttpClient.post("/surveys/survey", payload);

        // this.$snotify.success(
        //   `Troncal ${this.isEditMode ? "actualizado" : "creado"} con éxito.`,
        //   "¡Hecho!"
        // );
        this.$snotify.success(`Encuesta creada con éxito.`, "¡Hecho!");

        const SurveyId = data.encuesta.id;

        this.$router.push({ name: "Form builder", params: { SurveyId } });
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      }
    },
  },
};
</script>
